import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { JumpstartComponentsWkIconsModule, JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { FormsModule } from "@angular/forms";
import { AppLoaderComponent } from "../../../shared/components/app-loader/app-loader.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "dashboard-edit",
    templateUrl: "./dashboard-edit.component.html",
    styleUrl: "./dashboard-edit.component.scss",
    host: { class: "wk-sde" },
    imports: [JumpstartComponentsWkIconsModule, JumpstartComponentsModule, FormsModule, AppLoaderComponent, TranslatePipe],
})
export class DashboardEditComponent {
    bsModalRef = inject(BsModalRef);

    dashboard: any;
    title: string;
    loading: boolean;
    callback: Function;

    constructor() {}

    submitForm() {
        if (this.dashboard.Title.trim().length !== 0) {
            this.loading = true;
            this.callback(this.dashboard);
        }
    }
}
